import React, { createContext, useState, useContext, useEffect } from 'react';

const BranchFilterContext = createContext(null);

export const useBranchFilter = () => {
  const context = useContext(BranchFilterContext);
  if (!context) {
    throw new Error('useBranchFilter must be used within a BranchFilterProvider');
  }
  return context;
};

export const BranchFilterProvider = ({ children }) => {
  const [selectedBranchId, setSelectedBranchId] = useState(() => {
    // Load from localStorage on initialization
    const saved = localStorage.getItem('selectedBranchId');
    return saved ? (saved === 'all' ? null : parseInt(saved)) : null;
  });

  useEffect(() => {
    // Save to localStorage whenever it changes
    if (selectedBranchId === null) {
      localStorage.setItem('selectedBranchId', 'all');
    } else {
      localStorage.setItem('selectedBranchId', selectedBranchId.toString());
    }
  }, [selectedBranchId]);

  const value = {
    selectedBranchId,
    setSelectedBranchId,
    // Helper to check if "All" is selected
    isAllSelected: selectedBranchId === null,
  };

  return (
    <BranchFilterContext.Provider value={value}>
      {children}
    </BranchFilterContext.Provider>
  );
};

